import {ChangeDetectionStrategy, Component, input, InputSignal} from "@angular/core";
import {HtmlPipe} from '../../utils/html.pipe';

@Component({
    selector: "woa-receipt",
    templateUrl: "./receipt.component.html",
    styleUrl: "./receipt.component.scss",
    imports: [
        HtmlPipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReceiptComponent {
    public readonly receiptXml: InputSignal<string> = input.required<string>();
}
